var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-text text-container"},[_c('v-row',[_c('v-col',[_c('iframe',{ref:"iframe",attrs:{"src":_vm.url},on:{"load":_vm.onIframeLoad}})])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }